module.exports = __webpack_public_path__ + "images/canonical-card/duedate-icon.38bca72300926a576d5b.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/duedate-icon.svg
// module id = x52g
// module chunks = 0